import { connect } from 'react-redux';

import makeIsSubNotPaid from 'app/selectors/subs/isSubNotPaid';


// type Props = {
//   subId?: string | number,
// };

const subPayment = connect(() => {
  const isSubNotPaid = makeIsSubNotPaid();
  return (state, props) => ({
    notPaid: isSubNotPaid(state, props),
  });
});

export default subPayment;
